/**
 * <cta-sticky-concours>
 *
 * CTA fixe en bas a droite des pages concours. Au clic, il ouvre la carte du pack
 * passe dans data-target-pack (calcule cote Liquid : le pack le plus cher).
 *
 * On ne coche pas l'input nous-memes : on relaie le clic sur [data-card-selected],
 * le handler de product-info.js s'occupe du reste (coche l'input, ajoute
 * .is-card-selected, deplie [data-toggle-content], degele le carrousel Flickity et
 * publie PUB_SUB_EVENTS.packSelection, qui scrolle sur la carte). Dupliquer cette
 * logique ici la ferait diverger a la premiere evolution de product-info.js.
 */
if (!customElements.get("cta-sticky-concours")) {
  customElements.define(
    "cta-sticky-concours",
    class CtaStickyConcours extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector("[data-cta-sticky-button]");
        this.packId = this.dataset.targetPack;

        if (!this.trigger || !this.packId) return;

        this.trigger.addEventListener("click", this.openPack.bind(this));
      }

      openPack(event) {
        event.preventDefault();

        const card = document.getElementById(`MainProduct-${this.packId}`);
        if (!card) return;

        const input = card.querySelector("input[name='pack']");
        const selectable = card.querySelector("[data-card-selected]");

        // Carte deja ouverte : product-info.js ignore le clic (early return sur
        // input:checked), donc on se contente de ramener l'utilisateur dessus.
        if (input && input.checked) {
          smoothScrollToElement(card);
          return;
        }

        if (selectable) selectable.click();
      }
    }
  );
}
